import styled, { injectGlobal } from 'react-emotion';
import { space, color, themeGet } from 'styled-system';
import { FaEllipsisV } from 'react-icons/fa';
import { PanelFilter } from '../Filters';
import { bouncyBoyMixin } from '../../styles';

export const VisualisationWrapper = styled('section')`
  display: flex;
  width: 100%;
  height: 100%;
  ${color}
  ${space}
  transition: opacity 0.15s ease-in-out;
  opacity: ${props => props.visible ? 1 : 0};
  position: relative;
  border-radius: 10px;
`;

export const EditBorder = styled('div')`
  ${space}
  ${color}
  ${space}
  width: 100%;
  height: 100%;
  border: ${props => props.editing ? '1px #ddd dashed' : 'none'};
  border-radius: 5px;
  display: flex;
  transition: border 0.15s ease-in-out;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const NoVisualisation = styled(EditBorder)`
  svg {
    font-size: 3em;
  }

  h4 {
    color: inherit;
    font-weight: 100;
  }
`;

export const EditDashboardIcon = styled(FaEllipsisV)`
  position: absolute;
  ${color}
  margin: 15px 11px;
  font-size: 1.5em;
  right: 0;
  bottom: 0;
  cursor: pointer;
  &:hover {
    color: ${themeGet('colors.clientPrimary')};
  }
  &:before {
    position: absolute;
    top: 0;
    left:0;
    width: 2em;
    height: 2em;
    background: blue;
    border-radius: 50%;
  }
  ${bouncyBoyMixin}
`;

export const PanelFilterIcon = styled(PanelFilter)`
  position: absolute;
  margin-bottom: 8px;
  font-size: 1.3em;
  left: -4px;
  bottom: 0;
`;

// eslint-disable-next-line
const injectGlobalStylesForVisualisationSelection = () => injectGlobal`
  .DCRPVisualisationSelection .ant-dropdown-menu-item {
    padding: 1px 14px;
    font-size: 85%;
  }
`;

injectGlobalStylesForVisualisationSelection();
